// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"da8784f2","235":"03531e92","289":"f4455256","330":"34326f7a","453":"566326f7","471":"4da61e0d","730":"26ed2594","884":"290e3a4a"}[chunkId] + ".chunk.js";
};